// src/hooks/useAuth.js
import { useContext } from 'react';
import { AuthContext } from 'providers/AuthProvider';  // Import AuthContext correctly

export const useAuth = () => {
    const context = useContext(AuthContext);  // Access the AuthContext

    // Ensure that the hook is being used within the AuthProvider
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }

    // Return the context (this will include the current account, token, login, logout, etc.)
    return context;
};
